function Instructions() {
    try {
        return (
            <div className="mt-8 border-t pt-8" data-name="instructions">
                <h2 className="text-xl font-semibold mb-4">使用說明</h2>
                <div className="grid md:grid-cols-4 gap-6">
                    <div className="flex items-start space-x-3">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                            <i className="fas fa-upload text-green-600"></i>
                        </div>
                        <div>
                            <h3 className="font-medium mb-1">上傳檔案</h3>
                            <p className="text-sm text-gray-600">選擇或拖放多個 PDF 收據檔案</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-3">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                            <i className="fas fa-sync text-green-600"></i>
                        </div>
                        <div>
                            <h3 className="font-medium mb-1">批量轉換</h3>
                            <p className="text-sm text-gray-600">系統自動批量轉換成 Excel</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-3">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                            <i className="fas fa-check text-green-600"></i>
                        </div>
                        <div>
                            <h3 className="font-medium mb-1">完成處理</h3>
                            <p className="text-sm text-gray-600">系統確認轉換成功</p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-3">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                            <i className="fas fa-file-archive text-green-600"></i>
                        </div>
                        <div>
                            <h3 className="font-medium mb-1">打包下載</h3>
                            <p className="text-sm text-gray-600">將所有 Excel 檔案打包下載</p>
                        </div>
                    </div>
                </div>
                
                <div className="mt-6 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                    <h3 className="font-medium flex items-center text-yellow-800 mb-2">
                        <i className="fas fa-coins mr-2"></i>
                        點數說明
                    </h3>
                    <ul className="list-disc pl-5 text-sm text-yellow-700 space-y-1">
                        <li>每個 PDF 檔案轉換將扣除 1 點數</li>
                        <li>批量上傳 10 個檔案，將扣除 10 點數</li>
                        <li>轉換失敗的檔案仍會扣除點數</li>
                    </ul>
                </div>
            </div>
        );
    } catch (error) {
        console.error('Instructions component error:', error);
        reportError(error);
        return null;
    }
}

export default Instructions;